import { render, staticRenderFns } from "./WFieldPhone.vue?vue&type=template&id=7478202a&"
import script from "./WFieldPhone.vue?vue&type=script&lang=ts&"
export * from "./WFieldPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports